export const mesiLista = [
  { id: 1, mese: 'Gennaio' },
  { id: 2, mese: 'Febbraio' },
  { id: 3, mese: 'Marzo' },
  { id: 4, mese: 'Aprile' },
  { id: 5, mese: 'Maggio' },
  { id: 6, mese: 'Giugno' },
  { id: 7, mese: 'Luglio' },
  { id: 8, mese: 'Agosto' },
  { id: 9, mese: 'Settembre' },
  { id: 10, mese: 'Ottobre' },
  { id: 11, mese: 'Novembre' },
  { id: 12, mese: 'Dicembre' },
];
